import { useState } from 'react';
import clsx from 'clsx';
import styles from './TechWork.module.scss';
import { Container } from '../../Container/Container';
import { CrossIcon } from '../../Icons/Cross';
import Warning from '../../Icons/Warning';
import HTMLReactParser from 'html-react-parser';

const TechWork = ({ description }: { description: string }) => {
  const [close, setClose] = useState(false);
  return (
    <div className={clsx(styles.TechWork, { [styles.close]: close })}>
      <Container>
        <div className={styles.holder}>
          <div className={styles.text_holder}>
            <Warning />
            <p>{HTMLReactParser(description)}</p>
          </div>
          <button onClick={() => setClose(true)}>
            <CrossIcon />
          </button>
        </div>
      </Container>
    </div>
  );
};

export default TechWork;
